import styled, { css } from 'styled-components';
import { Flex } from 'reflexbox';

export const Sticky = styled(Flex)`
  position: sticky;
  width: 100%;
  ${({top}) => top ? css`top: ${top}` : 'top: 100px'};
`;
